// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d0c0011f5012b2c9035ca3d431be002025832878/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};